export default {"src":"/_next/static/media/cross.99fbced5.svg","height":16,"width":16};